import { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { Spinner } from 'enable-ui';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  handleLoadMore: () => void;
  hasMore: boolean;
}

export const InfiniteComp: FC<Props> = ({ handleLoadMore, hasMore, children }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <InfiniteScroll
        pageStart={1}
        loadMore={handleLoadMore}
        hasMore={hasMore}
        loader={
          <div style={{ color: '#262626', textAlign: 'center' }} key={0}>
            <Spinner style={{ margin: '8px 0' }} size={'md'} />
          </div>
        }
        useWindow={false}
      >
        {children}
      </InfiniteScroll>
    </div>
  );
};
